import { ArrowDown } from 'components/Icons'
import React from 'react'
import { CustomCollapse, CustomPanel } from './Collapse.style'

const Collapse = props => {
  return (
    <CustomCollapse expandIcon={() => <ArrowDown />}>
      <CustomPanel header={props.title}>
        <p>{props.children}</p>
      </CustomPanel>
    </CustomCollapse>
  )
}

export default Collapse
